/** Fleet-level telemetry coverage by data mode (LIVE / IMPORTED / MANUAL) — from /aiops/telemetry-coverage. */
import { useEffect, useState } from "react";
import api from "@/lib/api";
import { DataModeChip, fmtTs } from "./TelemetrySource";

export function TelemetryCoverage({ className = "" }) {
  const [c, setC] = useState(null);
  useEffect(() => { api.get("/aiops/telemetry-coverage").then(({ data }) => setC(data)).catch(() => setC(false)); }, []);
  if (!c) return null;
  return (
    <div className={`mt-1 space-y-0.5 text-[11px] ${className}`} data-testid="telemetry-coverage">
      <div>Telemetry coverage <b className="font-mono">{c.with_telemetry}</b> of {c.fleet} devices · <span className="text-slate-500">{c.without_telemetry} show “{c.message}”</span></div>
      <div className="flex flex-wrap items-center gap-1">{["LIVE", "IMPORTED", "MANUAL"].map((m) => <span key={m} className="inline-flex items-center gap-1"><DataModeChip mode={m} testid={`coverage-${m.toLowerCase()}`} /><span className="font-mono">{c.modes[m]}</span></span>)}{c.stale_30d > 0 && <span className="text-amber-700">· {c.stale_30d} stale &gt;30d</span>}</div>
      <div className="text-[10px] text-slate-500">Last updated {fmtTs(c.last_updated)}{c.simulated_remaining > 0 ? ` · ${c.simulated_remaining} simulated records hidden (purge in AI Ops → Ops)` : " · no simulated data"}</div>
    </div>
  );
}
